export const formatNumberDecimal = (num) => {
    // Redondeamos el número a un máximo de 5 decimales
    num = Math.round(num * 100) /100
    // num = Number(num?.toFixed(2));

    // Convertimos el número a una cadena y separamos la parte entera y decimal
    let parts = num.toString().split('.');
    parts[0] = isNaN(parts[0]) ? '0' : parts[0] ; 
    
    // Si el número no tiene parte decimal, añadimos '.00'
    if (parts.length === 1) {
      parts.push('00');
    }
    
    // Si la parte decimal tiene menos de 2 dígitos, añadimos ceros a la derecha
    if (parts[1].length < 2) {
      parts[1] = parts[1] + '0'.repeat(2 - parts[1].length);
    }
    
    // Separamos la parte entera en grupos de 3 dígitos
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    
    // Unimos la parte entera y decimal con un punto como separador decimal
    return parts.join('.');
  }

  export const formatNumber = (num) => {
    // Redondeamos el número a un máximo de 5 decimales
    num = Number(num?.toFixed(4));
    
    // Convertimos el número a una cadena y separamos la parte entera y decimal
    let parts = num.toString().split('.');
    
    // Si el número no tiene parte decimal, añadimos '.00'
    if (parts.length === 1) {
      parts.push('0000');
    }
    
    // Si la parte decimal tiene menos de 2 dígitos, añadimos ceros a la derecha
    if (parts[1].length < 4) {
      parts[1] = parts[1] + '0'.repeat(4 - parts[1].length);
    }
    
    // Separamos la parte entera en grupos de 3 dígitos
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    
    // Unimos la parte entera y decimal con un punto como separador decimal
    return parts.join('.');
  }

  export const formatSmallNumber = (value) =>{
   
    if(value >= 1000000){
        return formatNumberDecimal(value/1000000) + ' M'
    }else{
      if(value >= 1000){
        return formatNumberDecimal(value/1000) + ' k'
      }else{
         let num =value.toString().split('.')
        return num[0]
      }
    }
  }

  export  const PorcentajeFormat = (value) => {
    if (value) {
        return formatNumberDecimal(value) + ' %'
    } else {
        return 0.0 + ' %'
    }
}


  